import { IntakeFields } from "@/utils/booking";
import { create } from "zustand";
import { persist, devtools, createJSONStorage } from "zustand/middleware";
import { WeightLossInput } from "../@types/intake-form";

type AllergyType = {
  email: string;
  phone: string;
  Allergies: any;
};

interface AllergyState extends AllergyType {
  // eslint-disable-next-line no-unused-vars
  setData: (data?: AllergyType) => void;
}

interface WeightLossState extends WeightLossInput {
  // eslint-disable-next-line no-unused-vars
  setData: (data?: WeightLossInput) => void;
}

interface IntakeState extends IntakeFields {
  // eslint-disable-next-line no-unused-vars
  setData: (data?: IntakeFields) => void;
}

const allergyInfo: AllergyType = {
  email: "",
  phone: "",
  Allergies: {},
};

const intakeInfo: IntakeFields = {
  email: "",
  otp: "",
  id: "",
  birthControl: "",
  lastBoneDensity: "",
  lastMammogram: "",
  lastMenstrual: "",
  lastPelvicUltrasound: "",
  noAbortions: "",
  noChildren: "",
  noMiscarriages: "",
  noPregnancies: "",
  abnormalPap: "",
  gender: "",
  driverLicense: undefined,
  maritalStatus: "",
  previouslyTriedHormoneTherapy: "",
  stressAtHome: "",
  stressLevel: "",
  lastDigitalRectal: "",
  lastPsaProstate: "",
  lastColonoscopySigmoidoscopy: "",
  lastCardiacStress: "",
  desireChildren: "",
  insurerName: "",
  policyHolderName: "",
  policyNumber: "",
  groupNumber: "",
  cardiovascular: [],
  gastrointestinal: [],
  general: [],
  genitourinary: [],
  liverDisease: [],
  musculoskeletal: [],
  neurological: [],
  respiratory: [],
  surgicalProcedures: [],
  currentMeds: [],
  endocrine: [],
  autoImmune: [],
  psychiatric: [],
  lastPapSmear: "",
  type: "",
  when: "",
  status: "",
  primaryInsurance: undefined,
  secondaryInsurance: undefined,
  hasInsurance: false,
  submitting: false,
  Do_you_have_insurance: "",
};

const weightLossInfo: WeightLossInput = {
  desired_weight: "",
  diet_notes: "",
  exercise: {
    exercise_1: { type: "", hours_per_week: "" },
    exercise_2: { type: "", hours_per_week: "" },
    exercise_3: { type: "", hours_per_week: "" },
    exercise_4: { type: "", hours_per_week: "" },
    exercise_5: { type: "", hours_per_week: "" },
  },
  habits: {},
  weight_history: {
    current: { weight: "", age: "", notes: "" },
    highest: { weight: "", age: "", notes: "" },
    lowest: { weight: "", age: "", notes: "" },
  },
  motivation_for_losing_weight: "",
  eating_habits: {
    breakfast: { food_type: "", time: "" },
    dessert: { food_type: "", time: "" },
    dinner: { food_type: "", time: "" },
    lunch: { food_type: "", time: "" },
    snack: { food_type: "", time: "" },
    eat_to_relieve_stress_or_deal_with_emo: "",
    Do_you_have_a_history_of_disordered_eating: "",
    glasses_of_water_a_day: "",
    willing_to_make_diet_modifications: "",
    How_many_times_fast_food: "",
  },
};
export const useWeightLossStore = create<WeightLossState>()(
  devtools(
    persist(
      (set) => ({
        ...weightLossInfo,
        setData: (data?: WeightLossInput) =>
          set((state: WeightLossInput) => {
            if (!data)
              return {
                ...state,
                ...weightLossInfo,
              };
            return { ...state, ...data };
          }),
      }),
      {
        name: "intake-weightloss",
        storage: createJSONStorage(() => sessionStorage),
      },
    ),
  ),
);

export const useIntakeStore = create<IntakeState>()(
  devtools(
    persist(
      (set) => ({
        ...intakeInfo,
        setData: (data?: IntakeFields) =>
          set((state: IntakeFields) => {
            if (!data) {
              return { ...state, ...intakeInfo };
            }
            return { ...state, ...data };
          }),
      }),
      { name: "intake", storage: createJSONStorage(() => sessionStorage) },
    ),
  ),
);

const useAllergyStore = create<AllergyState>()(
  devtools(
    persist(
      (set) => ({
        ...allergyInfo,
        setData: (data?: AllergyType) =>
          set((state: AllergyType) => {
            if (!data) return { ...state, email: "", phone: "", Allergies: {} };
            return { ...state, ...data };
          }),
      }),
      {
        name: "intake-allergy",
        storage: createJSONStorage(() => sessionStorage),
      },
    ),
  ),
);

export default useAllergyStore;
